import { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import ui1 from "../../common/images/ui-1.png";
import ui2 from "../../common/images/ui-2.png";
import ui3 from "../../common/images/ui-3.png";
import ui4 from "../../common/images/ui-4.png";
import ui5 from "../../common/images/ui-5.png";
import ui6 from "../../common/images/ui-6.png";
import ui7 from "../../common/images/ui-7.png";

const tools = [
  { name: "FIGMA", image: ui1 },
  { name: "ADOBE XD", image: ui2 },
  { name: "SKETCH", image: ui3 },
  { name: "ADOBE PHOTOSHOP", image: ui4 },
  { name: "ADOBE ILLUSTRATOR", image: ui5 },
  { name: "COREL DRAW", image: ui6 },
  { name: "CANVA", image: ui7 },
];

export default function ToolsSlider() {
  const [index, setIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  useEffect(() => {
    const updateItemsToShow = () => {
      if (window.innerWidth < 769) {
        setItemsToShow(3);
      } else {
        setItemsToShow(5);
      }
    };

    updateItemsToShow();
    window.addEventListener("resize", updateItemsToShow);
    return () => window.removeEventListener("resize", updateItemsToShow);
  }, []);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % (tools.length - (itemsToShow - 1)));
  };

  const prevSlide = () => {
    setIndex(
      (prev) =>
        (prev - 1 + tools.length) % (tools.length - (itemsToShow - 1))
    );
  };

  return (
    <div className="max-w-[1280px] mx-auto bg-cover bg-no-repeat bg-top-right" style={{ backgroundImage: `url(/tools-back.png)` }}>
      <div className="w-full max-w-[900px] small:px-10 px-5 mx-auto text-center small:py-10 py-7">
        <h2 className="small:text-4xl text-3xl font-bold md:text-5xl text-center">
          Tools & Technologies We Use
        </h2>
        <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
          <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
        </div>
        <p className="text-black mt-2 mb-6 small:w-[50%] w-full mx-auto">
          We utilize a variety of powerful design tools to create visually captivating and user-centric interfaces.
        </p>
        <div className="relative flex items-center justify-center">
          <button
            onClick={prevSlide}
            className="absolute small:-left-20 -left-5 bg-secondary text-white p-3 rounded-full shadow-lg hover:bg-blue-900 z-10"
          >
            <FaArrowLeft className="text-webYellow" />
          </button>
          <div className="grid grid-cols-3 small:grid-cols-5 justify-between gap-6 overflow-hidden w-full">
            {tools.slice(index, index + itemsToShow).map((tool, i) => (
              <div key={i} className="bg-white flex flex-col items-center justify-center transition-transform transform">
                <img src={tool.image} alt={tool.name} className="w-full mb-3 object-contain" />
              </div>
            ))}
          </div>
          <button
            onClick={nextSlide}
            className="absolute small:-right-20 -right-5 bg-secondary text-white p-3 rounded-full shadow-lg hover:bg-blue-900 z-10"
          >
            <FaArrowRight className="text-webYellow" />
          </button>
        </div>
      </div>
    </div>
  );
}
